import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const EntryExtras = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 12px;
  margin: 0 30px;
  ${getFont(0)};

  ${maxMediaQueries.phablet`
    margin: 0 15px;
  `};
`;
